module.exports = {
  STATIC_PATH: __dirname,
};



//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/index.js
// module id = 504
// module chunks = 0